import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects";
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {postFakeLogin,} from "../../../helpers/fakebackend_helper";
import { clearAuthData, TIMEOUT_CONFIG, initializeSession } from "../../../helpers/auth-helper";

const fireBaseBackend = getFirebaseBackend();
const setSessionStorage = (token, userId, roleName, menuPermissions) => {
  sessionStorage.setItem("token", token);
  sessionStorage.setItem("userId", userId);
  sessionStorage.setItem("roleName", roleName);
  sessionStorage.setItem("menuPermissions", JSON.stringify(menuPermissions));
  // Initialize session timing
  initializeSession();
};
function* loginUser({ payload: { user, history } }) {
  try {
    let response;

    // Firebase Authentication
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      response = yield call(signInWithEmailAndPassword, auth, user.username, user.password);
      yield put(loginSuccess(response));
    } 
    
    // JWT Authentication
    else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      response = yield call(postJwtLogin, {
        username: user.username,
        password: user.password,
      });

      // Check if the response is successful and contains data
      if (response && response.data && !response.isError) {
        const { user_id, user_type, token, menu_permissions } = response.data;

        // Store necessary data in session storage
        setSessionStorage(token, user_id, user_type, menu_permissions);

        // Dispatch login success action
        yield put(loginSuccess(response.data));

        // Redirect based on role
        if (user_type === "ADMIN") {
          history("/AdminDashboard");
        } else {
          history("/dashboard");
        }
      } else {
        throw new Error(response.errorMessage || "Login failed");
      }
    }
    
    // Fake Backend Authentication
    else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      response = yield call(postFakeLogin, {
        username: user.username,
        password: user.password,
      });

      // Check if the response is successful and contains data
      if (response && response.data && !response.isError) {
        const { user_id, user_type, token, menu_permissions } = response.data;

        // Store necessary data in session storage
        setSessionStorage(token, user_id, user_type,menu_permissions);

        // Dispatch login success action
        yield put(loginSuccess(response.data));

        // Redirect based on role
        if (user_type === "ADMIN") {
          history("/AdminDashboard");
        } else {
          history("/dashboard");
        }
      } else {
        throw new Error(response.errorMessage || "Login failed");
      }
    }

    // Start auto-logout timer
    yield call(autoLogout, history);

  } catch (error) {
    const errorMessage = error.message || "An error occurred during login";
    console.error("Login error:", errorMessage);
    yield put(apiError(errorMessage));
  }
}


function* autoLogout(history) {
  try {
    // This function is now handled by the useSessionWarning hook
    // and session management in auth-helper.js
    // The actual auto-logout logic is moved to the frontend hook
    // to allow for session extension functionality
    console.log("Auto-logout timer initialized - managed by session warning hook");
  } catch (error) {
    console.error("Error in autoLogout:", error);
  }
}


function* logoutUser({ payload: { history } }) {
  try {
    // Use centralized auth helper for consistent cleanup
    clearAuthData();

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }
    history('/home');
  } catch (error) {
    yield put(apiError(error));
  }
}

function* socialLogin({ payload: { type, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, type);
      if (response) {
        const { roleName } = response;
        sessionStorage.setItem("roleName", roleName);
        history("/dashboard");
      } else {
        history("/login");
      }
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
  } catch (error) {
 
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;